import React from 'react'

const Content = ({
    children,
    isMe
}) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: isMe ? 'row-reverse' : 'row'
            }}
        >
            <div
                style={{
                    maxWidth: '600px',
                    width: '80%',
                    padding: '0px 10px 2px',
                    
                }}
            >
                <div
                    style={{
                        backgroundColor: isMe ? 'rgb(52, 118, 232' : 'rgb(224, 226, 232',
                        color: isMe ? 'white' : 'black',
                        borderRadius: '5px',
                        padding: '5px'
                    }}
                >
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Content
